import { useNavigate } from "react-router-dom";
import Topo from "../Topo/topo";
import { veiculosAPI } from "../../servicos/veiculos";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { FormField } from "../ui/form-field";
import { Controller, useForm } from "react-hook-form";
import { toast } from "sonner";


function Incluir() {

    const breadcrumbs = ['Home', 'Veículo', 'Novo'];

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors, isSubmitting },
    } = useForm({
        defaultValues: {
            ve100_dsc_chassi: '',
            ve100_num_renavam: '',
            ve100_dsc_placa: '',
            ve100_key_nfe: '',
        },
        mode: 'onBlur',
    });

    let navigate = useNavigate();
    const Voltar = () => {
        let path = '/filiado/veiculo';
        navigate(path);
    }

    const sanitizeChassi = (valor = '') => valor.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 17);
    const sanitizeRenavam = (valor = '') => valor.replace(/\D/g, '').slice(0, 11);
    const sanitizePlaca = (valor = '') => valor.replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 7);
    const sanitizeNfe = (valor = '') => valor.replace(/\D/g, '').slice(0, 44);

    const onSubmit = async (values) => {
        const payload = {
            ve100_dsc_chassi: sanitizeChassi(values.ve100_dsc_chassi),
            ve100_num_renavam: sanitizeRenavam(values.ve100_num_renavam),
            ve100_dsc_placa: sanitizePlaca(values.ve100_dsc_placa),
            ve100_key_nfe: sanitizeNfe(values.ve100_key_nfe),
        };

        try {
            await veiculosAPI.post('/', payload);
            toast.success('Veículo cadastrado com sucesso.');
            reset();
        } catch (erro) {
            let mensagem = 'Ops! Ocorreu um erro inesperado.';
            if (erro?.response?.data?.message) {
                mensagem = erro.response.data.message;
            } else if (erro.response?.status === 401) {
                mensagem = 'Ops! Sessão Expirada! Faça um novo login.';
            }
            toast.error(mensagem);
        }
    };

    const onInvalidSubmit = () => {
        toast.error('Por favor, corrija os campos destacados.');
    };

    return (
        <div class="row">
            <div class="container">
                <Topo titulo='Novo Veículo' breadcrumbs={breadcrumbs} btnincluir={false} admin={false}/>
                <div class="row row-padding-conteudo">
                    <div class="col-12">
                        <form class="row gy-4 gx-4" onSubmit={handleSubmit(onSubmit, onInvalidSubmit)}>
                            <div class="col-md-6">
                                <FormField
                                    id="ve100_dsc_chassi"
                                    label="Chassi"
                                    error={errors.ve100_dsc_chassi?.message}
                                >
                                    <Controller
                                        name="ve100_dsc_chassi"
                                        control={control}
                                        rules={{
                                            required: 'Informe o chassi.',
                                            validate: (valor) =>
                                                sanitizeChassi(valor).length === 17 ||
                                                'O chassi deve conter 17 caracteres.',
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                id="ve100_dsc_chassi"
                                                maxLength={17}
                                                onChange={(event) =>
                                                    field.onChange(sanitizeChassi(event.target.value))
                                                }
                                            />
                                        )}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="ve100_num_renavam"
                                    label="Renavam"
                                    error={errors.ve100_num_renavam?.message}
                                >
                                    <Controller
                                        name="ve100_num_renavam"
                                        control={control}
                                        rules={{
                                            validate: (valor) => {
                                                const digits = sanitizeRenavam(valor);
                                                return digits.length === 0 || digits.length === 11
                                                    ? true
                                                    : 'O Renavam deve conter 11 dígitos.';
                                            },
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                id="ve100_num_renavam"
                                                inputMode="numeric"
                                                maxLength={11}
                                                onChange={(event) =>
                                                    field.onChange(sanitizeRenavam(event.target.value))
                                                }
                                            />
                                        )}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="ve100_dsc_placa"
                                    label="Placa"
                                    error={errors.ve100_dsc_placa?.message}
                                >
                                    <Controller
                                        name="ve100_dsc_placa"
                                        control={control}
                                        rules={{
                                            validate: (valor) => {
                                                const sanitized = sanitizePlaca(valor);
                                                return sanitized.length === 0 || sanitized.length === 7
                                                    ? true
                                                    : 'A placa deve conter 7 caracteres.';
                                            },
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                id="ve100_dsc_placa"
                                                maxLength={7}
                                                onChange={(event) =>
                                                    field.onChange(sanitizePlaca(event.target.value))
                                                }
                                            />
                                        )}
                                    />
                                </FormField>
                            </div>
                            <div class="col-md-6">
                                <FormField
                                    id="ve100_key_nfe"
                                    label="Chave da NF-e"
                                    error={errors.ve100_key_nfe?.message}
                                >
                                    <Controller
                                        name="ve100_key_nfe"
                                        control={control}
                                        rules={{
                                            validate: (valor) => {
                                                const digits = sanitizeNfe(valor);
                                                return digits.length === 0 || digits.length === 44
                                                    ? true
                                                    : 'A chave deve conter 44 dígitos.';
                                            },
                                        }}
                                        render={({ field }) => (
                                            <Input
                                                {...field}
                                                id="ve100_key_nfe"
                                                inputMode="numeric"
                                                maxLength={44}
                                                onChange={(event) =>
                                                    field.onChange(sanitizeNfe(event.target.value))
                                                }
                                            />
                                        )}
                                    />
                                </FormField>
                            </div>
                            <div class="col-12 tw-flex tw-justify-end tw-gap-3 tw-pt-2">
                                <Button type="button" variant="outline" onClick={Voltar} className="tw-min-w-[120px] tw-text-slate-700 dark:tw-text-white">
                                    Voltar
                                </Button>
                                <Button type="submit" className="tw-min-w-[140px]" disabled={isSubmitting}>
                                    {isSubmitting ? 'Salvando...' : 'Salvar'}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Incluir;

